import React, {Component} from 'react';
import '../../pages/settingsPage/SettingsPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import CheckBox from '../../inputs/checkBox/CheckBox';
import mainAPI from '../../api/MainAPI';
import models from '../../model/models';
import toasts from '../../utils/toasts';
import debounce from 'lodash.debounce';
import Input from '../../inputs/input/Input';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import NotificationCard from "../../cards/notificationCard/NotificationCard";
import userGroupSettingsManager from '../../utils/UserGroupSettingsManager';
import SettingsTabBar from '../../components/settingsTabBar/SettingsTabBar';
import {SettingRow, invalidEmails} from '../settingsPage/SettingsPage';

const getTimezone = () => {
	return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export default class NotificationsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user_group: {},
		};
	}

	componentDidMount = async () => {
		this.subscribeId = models.user_group.onChange(this._getData);
		await this._getData();
	};

	componentWillUnmount = () => {
		if (this.subscribeId) {
			models.user_group.unsubscribe(this.subscribeId);
		}
	};

	_getData = async () => {
		let user_group = models.user_group.obj();
		if (!user_group) return;
		await userGroupSettingsManager.refresh(user_group.id);
		this.setState({user_group});
	};

	toggleSendExpiringReport = (value) => {
		this.toggleBoolean('send_expiring_report', value);
	};

	toggleMissingDrugNotificationEnabled = (value) => {
		this.toggleBoolean('missing_drug_notification_enabled', value);
	};

	toggleBoolean = async (columnName, value) => {
		value = value ? 1 : 0;
		await this.updateSetting(columnName, value);
	};

	updateSetting = async (key, value, successMessage) => {
		let user_group = this.state.user_group || {};
		let res = await mainAPI.user_group.update({id: user_group.id, [key]: value});

		if (res) {
			user_group = this.state.user_group || {};
			user_group[key] = res[key];
			this.setState({user_group});
			toasts.show(successMessage || 'Setting Updated');
		} else {
			toasts.show('Setting did not update');
		}
	};

	setMissingDrugNotificationEmails = debounce((value) => {
		value = value.toLowerCase().replace(/ /g, '');
		const invalid = invalidEmails(value);
		this.setState({invalidMissingDrugNotificationEmails: invalid});
		if (invalid.length > 0) {
			toasts.show('Invalid email');
			return;
		}
		this.updateSetting('missing_drug_notification_emails', value);
	}, 3000);

	updateTimezoneOffset = () => {
		const timezone = getTimezone();
		this.updateSetting('notification_timezone', timezone, 'timezone set to ' + timezone);
	};

	render() {
		let {
			send_expiring_report,
			missing_drug_notification_enabled,
			missing_drug_notification_emails,
			notification_timezone,
		} = this.state.user_group || {};

		return (
			<Page className="g-settings-page">
				<Card>
					<Label larger black>
						Account settings
					</Label>
					<div className="lower">
						<SettingsTabBar userGroup={this.state.user_group} />
						<div className={'notification-container'}>
							<NotificationCard
								after={<Label gray-dark>Additional notifications can be be set for each unit on the unit page.</Label>}
							/>

							<Card className="inner-card">
								<Label bold large black>
									Other Notifications
								</Label>
								<SettingRow>
									<CheckBox tabIndex="0" value={!!missing_drug_notification_enabled}
										onChange={this.toggleMissingDrugNotificationEnabled}/>
									<Label gray-dark>Send notification for box checks with missing drugs</Label>
								</SettingRow>

								{Boolean(missing_drug_notification_enabled) && <SettingRow className="full-width-input">
									<Label gray-dark>Emails wanting notifications for box checks with missing drugs</Label>
									<Label className={'email-example'} gray-dark>(e.g., email1@gmail.com,email2@yahoo.com)</Label>
									<Input value={missing_drug_notification_emails} onChange={this.setMissingDrugNotificationEmails}/>
									{this.state.invalidMissingDrugNotificationEmails && (
										<Label>invalid emails {this.state.invalidMissingDrugNotificationEmails}</Label>
									)}
								</SettingRow>}

								<SettingRow>
									<CheckBox tabIndex="0" value={!!send_expiring_report} onChange={this.toggleSendExpiringReport}/>
									<Label gray-dark>Send monthly notification of expiring drugs</Label>
								</SettingRow>
							</Card>
							<Card className="inner-card">
								<Label bold large black>
									Notification and Report Timezone
								</Label>

								<SettingRow>
									<PrimaryButton onClick={this.updateTimezoneOffset}>Update Timezone</PrimaryButton>
									<Label gray-dark>Update notification and report exports timezone ({notification_timezone})</Label>
								</SettingRow>
							</Card>
						</div>
					</div>
				</Card>
			</Page>
		);
	}
}




// WEBPACK FOOTER //
// ./src/pages/notificationsPage/NotificationsPage.jsx